export default __webpack_public_path__ + "static/NNNittiGrotesk-TextRegular-d4322fd26a434561dcad84ecf5747e92.woff";